import { render } from "./DropForm.vue?vue&type=template&id=4530e16c"
import script from "./DropForm.vue?vue&type=script&lang=js"
export * from "./DropForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__